import { convertTag2AgGridColDef } from '@/modules/reporting/services/ReportingService';
import { camelCaseFormat } from '@/core/filters/camelCaseFormat';

function headerValueGetter(params) {
  if (params.location === 'toolPanel') {
    return camelCaseFormat(params.colDef.tagObject.tagName);
  }

  return `${camelCaseFormat(params.colDef.tagObject.tagType)}:${camelCaseFormat(params.colDef.tagObject.tagName)}`;
}

export function groupTags(tags) {
  const subGroupCache = {};
  
  return tags.reduce((tagsGroupChildren, tag) => {
    let subGrouping = subGroupCache[tag.tagType];

    if (!subGrouping) {
      subGrouping = {
        headerName: camelCaseFormat(tag.tagType),
        children: [],
        ringbaGroupName: 'Tags'
      };
      subGroupCache[tag.tagType] = subGrouping;

      tagsGroupChildren.push(subGrouping);
    }

    subGrouping.children.push(convertTag2AgGridColDef(tag, {
      enableValue: true,
      enableRowGroup: false,
      sortable: false,
      suppressColumnsToolPanel: false,
      flex: 2,
      minWidth: 80,
      valueFormatter: (params) => params.value,
      cellClass: 'filterable-cell',
      tagObject: tag,
      headerValueGetter,
      headerClass: '',
    }));


    return tagsGroupChildren;
  }, []);
}